/* nav-overlay — owns the full-screen menu: open/close (from the bar MENU + SEARCH), backdrop/Esc
   close, body-scroll lock, focus management, and live predictive search (Shopify /search/suggest.json)
   rendered below the nav links so the menu items stay put. Replaces the old nav.js open/close. */
(function () {
  'use strict';

  var overlay = document.getElementById('nav-overlay');
  if (!overlay) return;

  var openers   = document.querySelectorAll('.open-nav, .search'); // bar: MENU + SEARCH
  var closeBtn  = overlay.querySelector('.close-nav');
  var form      = overlay.querySelector('[data-nav-search]');
  var input     = overlay.querySelector('[data-nav-search-input]');
  var results   = overlay.querySelector('[data-nav-search-results]');
  var lastFocus = null;

  /* ---------- open / close ---------- */
  function open(focusSearch) {
    if (overlay.classList.contains('is-open')) { if (focusSearch && input) input.focus(); return; }
    lastFocus = document.activeElement;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (focusSearch && input) setTimeout(function () { input.focus(); }, 60);
  }
  function close() {
    if (!overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    clearResults();
    if (input) input.value = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  openers.forEach(function (o) {
    o.addEventListener('click', function (e) {
      e.preventDefault();
      open(o.classList.contains('search')); // opened via SEARCH → drop focus straight into the field
    });
  });
  if (closeBtn) closeBtn.addEventListener('click', function (e) { e.preventDefault(); close(); });
  // backdrop only — clicks on the search field / links must NOT close the menu
  overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });

  /* ---------- predictive search ---------- */
  if (!input || !results) return;

  var controller = null;
  var debounce = null;
  var MIN = 2;
  var moneyFormat = (form && form.getAttribute('data-money-format')) || '{{amount}}';
  var hi = -1; // arrow-key highlight index

  // suggest.json returns price as a bare amount ("850.00") — run it through the shop's money format
  function money(price) {
    if (price == null || price === '') return '';
    return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/gi, price);
  }

  function clearResults() {
    results.innerHTML = '';
    results.hidden = true;
    hi = -1;
    if (controller) { controller.abort(); controller = null; }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // request a small, retina-friendly version of the product image off the Shopify CDN
  function thumbUrl(url) {
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=120';
  }
  function searchUrl(q) {
    return (form.getAttribute('action') || '/search') + '?q=' + encodeURIComponent(q);
  }

  function group(label, items, withPrice, withThumb) {
    if (!items || !items.length) return '';
    var rows = items.map(function (it) {
      var thumb = withThumb && it.image
        ? '<img class="nav-result__thumb" src="' + escapeHtml(thumbUrl(it.image)) + '" alt="" loading="lazy">'
        : '';
      var meta = withPrice && it.price ? '<span class="nav-result__meta">' + escapeHtml(money(it.price)) + '</span>' : '';
      return '<a class="nav-result' + (withThumb ? ' nav-result--product' : '') + '" href="' + encodeURI(it.url) + '">'
           +   thumb
           +   '<span class="nav-result__title">' + escapeHtml(it.title) + '</span>' + meta
           + '</a>';
    }).join('');
    return '<div class="nav-result-group">'
         +   '<div class="nav-result-group__label">' + label + '</div>' + rows
         + '</div>';
  }

  function render(q, res) {
    var html = group('Products', res.products, true, true)
             + group('Pages', res.pages, false, false)
             + group('Collections', res.collections, false, false);
    if (html) {
      html += '<a class="nav-results__all" href="' + escapeHtml(searchUrl(q)) + '">View all results</a>';
      results.innerHTML = html;
    } else {
      results.innerHTML = '<p class="nav-results__empty">No matches for &ldquo;' + escapeHtml(q) + '&rdquo;</p>';
    }
    results.hidden = false;
    hi = -1;
  }

  function run(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
            + '&resources[type]=product,page,collection'
            + '&resources[limit]=5'
            + '&resources[options][unavailable_products]=last';
    fetch(url, { signal: controller.signal, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) { render(q, (data.resources && data.resources.results) || {}); })
      .catch(function (err) { if (err !== 20 && err && err.name !== 'AbortError') clearResults(); });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(debounce);
    if (q.length < MIN) { clearResults(); return; }
    debounce = setTimeout(function () { run(q); }, 220);
  });

  // keyboard: ↑/↓ to move through results, Enter to open the highlighted one (else the form submits
  // to the full /search?q= page — native fallback).
  function navItems() { return Array.prototype.slice.call(results.querySelectorAll('a')); }
  function highlight(idx) {
    var list = navItems();
    list.forEach(function (el) { el.classList.remove('is-highlighted'); });
    if (!list.length) { hi = -1; return; }
    hi = (idx + list.length) % list.length;
    list[hi].classList.add('is-highlighted');
    list[hi].scrollIntoView({ block: 'nearest' });
  }
  input.addEventListener('keydown', function (e) {
    if (results.hidden) return;
    var list = navItems();
    if (e.key === 'ArrowDown') { e.preventDefault(); highlight(hi + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(hi - 1); }
    else if (e.key === 'Enter' && hi >= 0 && list[hi]) { e.preventDefault(); window.location.href = list[hi].getAttribute('href'); }
  });
})();
